// src/components/PdfPreview.jsx
import { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc =
  `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

export default function PdfPreview({ fileUrl }) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [numPages, setNumPages] = useState(null);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let revokedUrl;

    const loadPdf = async () => {
      try {
        setLoading(true);
        setError(false);

        const res = await fetch(fileUrl);
        const blob = await res.blob();

        const url = URL.createObjectURL(blob);
        revokedUrl = url;
        setBlobUrl(url);
      } catch (e) {
        console.error("PDF fetch failed", e);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    loadPdf();

    return () => {
      if (revokedUrl) URL.revokeObjectURL(revokedUrl);
    };
  }, [fileUrl]);

  const onLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setPage(1);
  };

  if (loading) {
    return (
      <div className="p-4 text-sm text-gray-600">
        Loading PDF…
      </div>
    );
  }

  if (error || !blobUrl) {
    return (
      <div className="p-4 text-sm text-red-600">
        Failed to load PDF
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center gap-3 w-full">
      <div className="w-full bg-gray-50 border rounded overflow-auto max-h-[60vh] flex justify-center">
        <Document
          file={blobUrl}
          onLoadSuccess={onLoadSuccess}
          loading={null}
        >
          <Page
            pageNumber={page}
            width={420}
            renderTextLayer={false}
            renderAnnotationLayer={false}
          />
        </Document>
      </div>

      {numPages > 1 && (
        <div className="flex items-center gap-3">
          <button
            onClick={() => setPage((p) => Math.max(1, p - 1))}
            disabled={page === 1}
            className="px-2 py-1 border rounded text-xs disabled:opacity-50"
          >
            Prev
          </button>

          <span className="text-xs text-gray-700">
            Page {page} of {numPages}
          </span>

          <button
            onClick={() => setPage((p) => Math.min(numPages, p + 1))}
            disabled={page === numPages}
            className="px-2 py-1 border rounded text-xs disabled:opacity-50"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}